// eslint-disable-next-line
import React from "react";
import GetCategoryProduct from "../components/categoryProduct/GetCategoryProduct ";
import HorizontalCardProduct from "../components/HorizontalCardProduct/HorizontalCardProduct";
import VerticalCardProduct from "../components/VerticalCardProduct/VerticalCardProduct";
import SwiperCard from "../components/SwiperCard/SwiperCard";
import VideoCarousel from "./VideoCarousel";
import Model from "./Model";

import * as Sentry from '@sentry/react';
import ShowAllProducts from "../components/ShowAllProducts/ShowAllProducts";
import DiscountCardSwiper from "../components/DiscountCardSwiper/DiscountCardSwiper";

const Home = () => {
  return (
    <div className="mx-auto p-4 ">
     
        <Model />

      <GetCategoryProduct />

      <VerticalCardProduct category="mobiles" heading="Mobiles" />

      <VideoCarousel />

      <HorizontalCardProduct category="airpods" heading="Top's Airpods" />

      <ShowAllProducts />

      <HorizontalCardProduct category="watches" heading="Popular's watches" />

       <SwiperCard />

      <VerticalCardProduct category="earphones" heading="Wired Headphones" />

      <ShowAllProducts />

      <VerticalCardProduct category="camera" heading="Camera & Photography" />

      <DiscountCardSwiper />

      <VerticalCardProduct category="televisions" heading="Televisions" />


     
    </div>
  );
};

export default Sentry.withProfiler(Home);

